function _getRootTitle(schema, uiSchema) {
  var result;
  if (uiSchema && uiSchema['ui:title']) {
    if (typeof uiSchema['ui:title'] === 'object') {
      result = uiSchema['ui:title']['text'];
    } else {
      result = uiSchema['ui:title'];
    }
  } else if (schema) {
    result = schema.title;
  }
  return result;
}
export default function isRootObject(idSchema, formContext, title) {
  var result = idSchema.$id === '';
  if (result) {
    var titleText = typeof title === 'object' ? title.text : title;
    var rootTitle = _getRootTitle(formContext.schema, formContext.uiSchema);
    result = titleText === rootTitle;
  }
  return result;
}